import {
  EXTENDED_WARRANTY_PROGRAM_TYPES,
  ExtendedWarrantyDealerInformation,
  ProgramType,
  RedactedExtendedWarrantyDealerInformation,
} from 'types';

export type WarrantyDealerEntry = ExtendedWarrantyDealerInformation | RedactedExtendedWarrantyDealerInformation;

export type WarrantyRow = WarrantyDealerEntry & { programType: ProgramType };

/**
 * Splits each warranty dealer entry into one row per program type: a provider's own SKU
 * mappings win when present and warranty-eligible; a legacy provider with no mappings at all
 * falls back to the org's warranty-eligible program types.
 */
export const getWarrantyRows = (
  dealerInfo: WarrantyDealerEntry[] | undefined,
  orgProgramTypes: ProgramType[] | undefined,
): WarrantyRow[] => {
  const orgWarrantyProgramTypes = (orgProgramTypes ?? []).filter((programType) =>
    EXTENDED_WARRANTY_PROGRAM_TYPES.has(programType),
  );

  const rows: WarrantyRow[] = [];

  for (const provider of dealerInfo ?? []) {
    const mappings = provider.contractSkuTermMappings ?? [];
    const ownProgramTypes = [...new Set(mappings.map((mapping) => mapping.programType))].filter((programType) =>
      EXTENDED_WARRANTY_PROGRAM_TYPES.has(programType),
    );

    let programTypesForRows: ProgramType[];
    if (mappings.length === 0) {
      programTypesForRows = orgWarrantyProgramTypes;
    } else if (ownProgramTypes.length > 0) {
      programTypesForRows = ownProgramTypes;
    } else {
      programTypesForRows = [];
    }

    for (const programType of programTypesForRows) {
      rows.push({ ...provider, programType });
    }
  }

  return rows;
};
